export async function fetchToken(livechatUuid) {
  try {
    const result = await fetch(`${process.env.REACT_APP_LIVECHAT_GO_SERVICE}/token`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'POST'
      },
      body: JSON.stringify({ livechat_uuid: livechatUuid }),
      credentials: 'include'
    });
    const parsed = await result.json();

    return parsed.token;
  } catch (error) {
    throw error;
  }
}

export function parseJWT(token) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join('')
  );

  return JSON.parse(jsonPayload);
}
